import axios from '../../api/vue-axios/axios'

const state = {
  networkRetailers: []
}

const mutations = {
  setNetworkRetailers (state, networkRetailers) {
    state.networkRetailers = networkRetailers
  }
}

const getters = {
  networkRetailers (state) {
    return state.networkRetailers
  }
}

const actions = {
  getNetworkRetailers (context, script_id) {
    return axios.get('network_retailers?active=true').then((response) => {
      context.commit('setNetworkRetailers', response.data.network_retailers)
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/networkRetailers.js